const PLUGIN_TOOLBAR_SIZE_BUTTON = "plugin-toolbar-size-button";
const SIZE_DROPDOWN_OPTION_CONTENT = "size-dropdown-option-content";
const SIZE_DROPDOWN_OPTION_SMALL = "size-dropdown-option-small";
const SIZE_DROPDOWN_OPTION_ORIGINAL = "size-dropdown-option-original";
const SIZE_DROPDOWN_OPTION_FULL_WIDTH = "size-dropdown-option-full-width";
const PLUGIN_TOOLBAR_ALIGNMENT_BUTTON = "plugin-toolbar-alignment-button";
const ALIGNMENT_DROPDOWN_OPTION_LEFT = "alignment-dropdown-option-left";
const ALIGNMENT_DROPDOWN_OPTION_CENTER = "alignment-dropdown-option-center";
const ALIGNMENT_DROPDOWN_OPTION_RIGHT = "alignment-dropdown-option-right";
const ALIGNMENT_DROPDOWN_OPTION_TEXT_WRAP = "alignment-dropdown-option-text-wrap";
const PLUGIN_TOOLBAR_SETTINGS_BUTTON = "plugin-toolbar-settings-button";
const PLUGIN_TOOLBAR_REPLACE_BUTTON = "plugin-toolbar-replace-button";
const PLUGIN_TOOLBAR_DELETE_BUTTON = "plugin-toolbar-delete-button";
const REVEAL_SPOILER_BTN = "reveal-spoiler-button";
const REVEAL_SPOILER_CONTENT = "reveal-spoiler-content";
const SPOILER_TEXT_AREA = "spoiler-text-area";
const SPOILER_CONTAINER = "spoiler-container";
export {
  ALIGNMENT_DROPDOWN_OPTION_CENTER,
  ALIGNMENT_DROPDOWN_OPTION_LEFT,
  ALIGNMENT_DROPDOWN_OPTION_RIGHT,
  ALIGNMENT_DROPDOWN_OPTION_TEXT_WRAP,
  PLUGIN_TOOLBAR_ALIGNMENT_BUTTON,
  PLUGIN_TOOLBAR_DELETE_BUTTON,
  PLUGIN_TOOLBAR_REPLACE_BUTTON,
  PLUGIN_TOOLBAR_SETTINGS_BUTTON,
  PLUGIN_TOOLBAR_SIZE_BUTTON,
  REVEAL_SPOILER_BTN,
  REVEAL_SPOILER_CONTENT,
  SIZE_DROPDOWN_OPTION_CONTENT,
  SIZE_DROPDOWN_OPTION_FULL_WIDTH,
  SIZE_DROPDOWN_OPTION_ORIGINAL,
  SIZE_DROPDOWN_OPTION_SMALL,
  SPOILER_CONTAINER,
  SPOILER_TEXT_AREA
};
//# sourceMappingURL=data-hooks.js.map
